import { Row } from '@klickly/front-packages';
import styled from 'styled-components';

export const StyledRow = styled(Row)`
    height: 100%;
    align-items: center;
`;
